<template>
  <div>
    <v-input placeholder="名称/像素高度/像素宽度"
             v-model="queryValue"
             style="width:200px;display:inline-block"></v-input>

    <v-button type="primary"
              @click="query">查找规格</v-button>
    <v-button type="primary"
              @click="selectMove">批量移动</v-button>
    <v-button type="primary"
              @click="exportSize">导出规格</v-button>
    <v-upload :name="name"
              :action="action"
              accept=".xlsx"
              :header="header"
              @change="onChange">
      <v-button type="ghost">
        <v-icon type="upload"></v-icon>上传规格
      </v-button>
    </v-upload>
    <div style="height:20px;"></div>
    <v-row>
      <v-col span="12">
        <el-table :data="tableData1"
                  style="width: 80%">
          <el-table-column type="index"
                           width="50">
          </el-table-column>
          <el-table-column prop="group_name"
                           label="分组名称">
          </el-table-column>
          <el-table-column prop="group_weights"
                           label="分组权重">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="viewClick(scope.row)"
                         size="small">查看规格</el-button>
              <el-button type="text"
                         @click="editGroup(scope.row)"
                         size="small">修改</el-button>
              <el-button slot="reference"
                         @click="delGroup(scope.row)"
                         type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </v-col>
      <v-col span="12">
        <el-table :data="tableData2"
                  @selection-change="handleSelectionChange"
                  style="width: 95%">
          <el-table-column type="selection"
                           width="55">
          </el-table-column>
          <el-table-column prop="spec_id"
                           label="规格ID">
          </el-table-column>
          <el-table-column prop="spec_name"
                           label="规格名称">
          </el-table-column>
          <el-table-column prop="weights"
                           label="规格权重">
          </el-table-column>
          <el-table-column prop="state"
                           :formatter="formatState"
                           label="规格状态">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="yidong(scope.row.spec_id)"
                         size="small">移动</el-button>
              <el-button type="text"
                         v-if="scope.row.state === 0"
                         size="small"
                         @click="preventSize(scope.row.spec_id)">禁用</el-button>
              <el-button type="text"
                         v-if="scope.row.state === 1"
                         size="small"
                         @click="openSize(scope.row.spec_id)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </v-col>
    </v-row>
    <v-modal title="编辑分类"
             :visible="visible"
             @ok="saveEdit"
             @cancel="cancelEdit">
      <span>名称</span>
      <v-input v-model="editNewName"></v-input>
      <div style="height:20px;"></div>
      <span>排序权重</span>
      <v-input-number style="width:100%"
                      v-model="editQuan"
                      :min="1"></v-input-number>
      <span style="color:gray">越大越靠前。</span>
    </v-modal>
    <v-modal title="移动规格"
             :visible="yidongVisible"
             @ok="saveYidong"
             @cancel="cancelYidong">
      <span>分组名称</span>
      <v-input v-model="groupName"></v-input>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      header: { 'server-mode': this.$store.state.serverMode },
      name: 'specs',
      action: '/dev/update_spec',
      queryValue: '',
      yidongVisible: false,
      visible: false,
      currentPage: 1,
      tableData1: [],
      tableData2: [],
      yidongID: '',
      groupName: '',
      editName: '',
      editNewName: '',
      editQuan: '',
      multipleSelection: [],
      yidongMode: ''
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    selectMove () {
      console.log(this.multipleSelection)
      if (this.multipleSelection.length === 0) {
        this.$message['error']('请选择要移动的规格')
        return
      }
      this.yidongMode = 'more'
      this.yidongVisible = true
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        this.$notification.warning({
          message: '警告',
          description: '上传中,请勿做其他操作',
          duration: 0,
          selfKey: 'noClose'
        })
      }
      if (info.file.status === 'done') {
        this.$notification.close('noClose')
        this.$notification.success({
          message: '成功',
          description: '上传成功'
        })
      } else if (info.file.status === 'error') {
        this.$notification.close('noClose')
        this.$notification.success({
          message: '失败',
          description: '上传失败'
        })
      }
    },
    openSize (id) {
      axios.post('/dev/start_spec/' + id)
        .then(res => {
          if (res.data.code === 200) {
            this.$message['success']('启用规格成功')
            this.inintData()
          }
        })
    },
    preventSize (id) {
      axios.post('/dev/disable_spec/' + id)
        .then(res => {
          if (res.data.code === 200) {
            this.$message['success']('禁用规格成功')
            this.inintData()
          }
        })
    },
    formatState (row, column, cellValue, index) {
      if (cellValue === 0) return '正常'
      if (cellValue === 1) return '禁用'
    },
    exportSize () {
      axios.get('/dev/export_spec')
        .then(res => {
          if (res.data.download_link) {
            window.location.href = res.data.download_link
          }
        })
    },
    uploadSize () {

    },
    delGroup (row) {
      console.log(row)
      this.$modal.confirm({
        iconType: 'frown',
        title: '确认删除',
        content: '是否删除这个分组',
        okText: '是的',
        cancelText: '我再想想',
        width: 300,
        onOk: _ => {
          let url = '/dev/delete_group/' + row.group_name
          axios.post(url)
            .then(res => {
              if (res.data.code === 200) {
                this.$message['success']('删除分组成功')
                this.inintData()
              }
            })
        }
      })
    },
    saveEdit () {
      if (this.editNewName === '') {
        this.$message['error']('请输入分组名称')
        return
      }
      if (this.editQuan === '') {
        this.$message['error']('请输入分组权重')
        return
      }
      let url = '/dev/change_group/' + this.editName
      axios.post(url, { new_group_name: this.editNewName, new_group_weights: +this.editQuan })
        .then(res => {
          if (res.data.code === 200) {
            this.$message['success']('修改分组成功')
            this.editName = ''
            this.editNewName = ''
            this.editQuan = ''
            this.visible = false
            this.inintData()
          }
        })
    },
    cancelEdit () {
      this.editName = ''
      this.editNewName = ''
      this.editQuan = ''
      this.visible = false
    },
    editGroup (row) {
      this.editName = row.group_name
      this.editNewName = row.group_name
      this.editQuan = row.group_weights
      this.visible = true
    },
    cancelYidong () {
      this.yidongID = ''
      this.groupName = ''
      this.yidongVisible = false
    },
    saveYidong () {
      if (this.groupName === '') {
        this.$message['error']('请输入分组名称')
        return
      }
      if (this.yidongMode === 'single') {
        let url = '/dev/spec_group/' + this.yidongID
        axios.post(url, { group_name: this.groupName })
          .then(res => {
            if (res.data.code === 200) {
              this.$message['success']('分组成功')
              this.yidongID = ''
              this.groupName = ''
              this.yidongVisible = false
              this.inintData()
            }
          })
      } else {
        // 批量移动
        let arr = []
        this.multipleSelection.forEach(item => {
          arr.push(item.spec_id)
        })
        axios.post('/dev/spec_group', { group_name: this.groupName, spec_id_list: arr })
          .then(res => {
            if (res.data.code === 200) {
              this.$message['success']('分组成功')
              this.groupName = ''
              this.yidongVisible = false
              this.inintData()
            }
          })
      }
    },
    yidong (id) {
      this.yidongID = id
      this.yidongMode = 'single'
      this.yidongVisible = true
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    },
    handleClick () {
    },
    query () {
      this.$router.push({ path: '/main/formatQuery', query: { queryValue: this.queryValue } })
    },
    viewClick (row) {
      this.$router.push({ path: '/main/formatView', query: { groupName: row.group_name } })
    },
    inintData () {
      // 获取分组数据
      axios.get('/dev/all_spec_group')
        .then(res => {
          this.tableData1 = res.data.result
        })
      // 获取未分组数据
      axios.get('/dev/all_independent_specs')
        .then(res => {
          this.tableData2 = res.data.result
        })
    }
  },
  created () {
    this.inintData()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/format/format-manager.vue